export const DEFAULT_BACKGROUND = '#0000FF'
export const FRIEND_BACKGROUND = '#0000FF'
export const FLIRT_BACKGROUND = '#C01860'
export const FUN_BACKGROUND = '#FF0000'
